import request from '@/utils/request'


// 查询提现申请列表
export function listApply(query) {
  return request({
    url: '/withdraw/apply/list',
    method: 'get',
    params: query
  })
}

// 查询提现申请分页
export function pageApply(query) {
  return request({
    url: '/withdraw/apply/page',
    method: 'get',
    params: query
  })
}

// 查询提现申请详细
export function getApply(data) {
  return request({
    url: '/withdraw/apply/detail',
    method: 'get',
    params: data
  })
}

// 新增提现申请
export function addApply(data) {
  return request({
    url: '/withdraw/apply/add',
    method: 'post',
    data: data
  })
}

// 修改提现申请
export function updateApply(data) {
  return request({
    url: '/withdraw/apply/edit',
    method: 'post',
    data: data
  })
}

// 审核提现申请
export function checkApply(data) {
  return request({
    url: '/withdraw/apply/check',
    method: 'post',
    data: data
  })
}

// 删除提现申请
export function delApply(data) {
  return request({
    url: '/withdraw/apply/delete',
    method: 'post',
    data: data
  })
}
